import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { INCENTIVE_PERMISSION_KEYS } from "@/other/constants/IncentiveKeys.jsx";

export class IncentiveBoardPreference extends HasProjectMixin(Model) {
  static get $name() {
    return "IncentiveBoardPreference";
  }

  static get fields() {
    return [
      { name: "boardId", dataSource: "board" },
      { name: INCENTIVE_PERMISSION_KEYS.INCENTIVE_MANAGERS, dataSource: "incentives_managers" },
      { name: INCENTIVE_PERMISSION_KEYS.POINT_APPROVERS, dataSource: "points_approvers" },
      { name: INCENTIVE_PERMISSION_KEYS.POINT_AWARDERS, dataSource: "points_awarders" },
      { name: INCENTIVE_PERMISSION_KEYS.POINT_ARCHIVERS, dataSource: "points_archivers" },
      { name: INCENTIVE_PERMISSION_KEYS.POINT_DELETERS, dataSource: "points_deleters" },
      { name: INCENTIVE_PERMISSION_KEYS.INCENTIVE_VIEW, dataSource: "incentives_view_grant" },
      { name: INCENTIVE_PERMISSION_KEYS.PENDING_POINTS_VIEW, dataSource: "pending_points_view_grant" },
      { name: INCENTIVE_PERMISSION_KEYS.APPROVED_POINTS_VIEW, dataSource: "approved_points_view_grant" },
      { name: INCENTIVE_PERMISSION_KEYS.DENIED_POINTS_VIEW, dataSource: "denied_points_view_grant" },
      { name: INCENTIVE_PERMISSION_KEYS.AWARDED_POINTS_VIEW, dataSource: "awarded_points_view_grant" },
    ];
  }

}
